<template>
    <div id="tab-bar" v-if="!route.meta.notUseTabBar">
        <div class="pc-max-width w-full h-[64px] border-t border-[#F1F1F3] fixed bottom-0 bg-white px-16 py-7 flex items-center justify-between">
            <div class="flex flex-col items-center cursor-pointer" @click="router.push({ name: 'main' })">
                <div class="px-6">
                    <icon-home :active="route.name === 'main' ? true : false"/>
                </div>
                <p class="text-12" :class="route.name === 'main' ? 'text-black' : 'text-gray1'">
                    {{ $t('components.tab_bar.home') }}
                </p>
            </div>
            <div
                class="flex flex-col items-center cursor-pointer"
                @click="router.push({name: 'shopping-influencer'})"
            >
                <div class="px-6">
                    <icon-clothes :active="route.name.startsWith('shopping-') ? true : false"/>
                </div>
                <p class="text-12" :class="route.name.startsWith('shopping-') ? 'text-black' : 'text-gray1'">
                    {{ $t('components.tab_bar.shopping') }}
                </p>
            </div>
            <div
                class="flex flex-col items-center cursor-pointer"
                @click="router.push({name: 'my_page-wallet'})"
            >
                <div class="px-6">
                    <icon-wallet :active="route.name === 'my_page-wallet' ? true : false"/>
                </div>
                <p class="text-12" :class="route.name === 'my_page-wallet' ? 'text-black' : 'text-gray1'">
                    {{ $t('components.tab_bar.wallet') }}
                </p>
            </div>
            <div
                class="flex flex-col items-center cursor-pointer"
                @click="router.push({name: 'community'})"
            >
                <div class="px-6">
                    <icon-community :active="route.name === 'community' ? true : false"/>
                </div>
                <p class="text-12" :class="route.name === 'community' ? 'text-black' : 'text-gray1'">
                    {{ $t('components.tab_bar.community') }}
                </p>
            </div>
            <div class="flex flex-col items-center cursor-pointer" @click="router.push({ name: 'my_page' })">
                <div class="px-6">
                    <icon-my :active="route.name === 'my_page' ? true : false"/>
                </div>
                <p class="text-12" :class="route.name === 'my_page' ? 'text-black' : 'text-gray1'">
                    {{ $t('components.tab_bar.mypage') }}
                </p>
            </div>
        </div>
    </div>
</template>
<script setup lang="ts">
    const route = useRoute();
    const router = useRouter();
</script>
